const additionalChargesStyle = {
  inputFormContainer: {
    marginTop: '20px',
    marginLeft: '30px',
    width: '600px',
  },
}

export default additionalChargesStyle
